import React from 'react';
// @ts-ignore
import { PrivacyPolicyPage } from 'zerocode';

const PrivacyPolicy = () => {
	return <PrivacyPolicyPage app="workflux" />;
};

export default PrivacyPolicy;
